import React, { useEffect, Fragment, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Popconfirm, Select, Drawer,
} from 'antd';
import PropTypes from 'prop-types';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import TenantActions from '@Actions/tenantActions';
import UserActions from '@Actions/userActions';
import MemberActions from '@Actions/memberActions';
import H3Text from '@Uilib/h3Text';
import {
  EditOutlined, MailOutlined, PhoneOutlined, SecurityScanFilled,
} from '@ant-design/icons';
import Helpers from '@Apis/helpers';
import { CountryCodes } from '@Apis/constants';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import MemberForm from './MemberForm';
import './style.scss';

const { Option } = Select;

/**
 *
 */
const Members = ({
  user, getMembers, getMembersLoading, members,
}) => {
  const [isUserReady, setIsUserReady] = useState(false);
  const [showCreateMemberModal, setShowCreateMemberModal] = useState(false);
  const [showUpdateMemberModal, setShowUpdateMemberModal] = useState(false);
  const [call, setCall] = useState(false);
  const [selectedMember, setSelectedMember] = useState('');

  useEffect(() => {
    if (!isUserReady) {
      getMembers();
      setIsUserReady(true);
    }
  }, []);

  useEffect(() => {
    getMembers();
  }, [call]);

  const rolecolumns = [
    {
      title: '',
      render: (record) => (
        <div onClick={() => setSelectedMember(record)}>
          <div className="mobile-list__item">
            <div style={{ display: 'flex' }}>
              <div>
                <div
                  style={{
                    fontWeight: '600', fontSize: '12px', cursor: 'pointer',
                  }}
                >
                  {`${record.first_name ? record.first_name : ''} ${record.last_name ? record.last_name : ''} (${record.tenant_role_name || '-'})`}
                </div>
              </div>
              <div className={`mobile-list__item-status ${record?.is_active ? 'status-tag' : 'status-tag__inactive'}`}>
                {record?.is_active ? 'Active' : 'Inactive'}
                {' '}
              </div>
            </div>
            <H3Text text={`Designation - ${record?.designation || '0'}`} className="mobile-list__item-info" />
            {record.username && (
              <div className="mobile-list__item-info">
                <div><MailOutlined /></div>
                <div style={{ marginLeft: '5px', marginTop: '2px' }}>{`${record.username || '-'}`}</div>
              </div>
            )}
            {record.mobile && (
              <div className="mobile-list__item-info">
                <div><PhoneOutlined /></div>
                <div style={{ marginLeft: '5px', marginTop: '2px' }}>{`${record.mobile || '-'}`}</div>
              </div>
            )}
          </div>
        </div>
      ),
      responsive: ['xs'],
    },
    {
      title: 'MEMBER NAME',
      render: (text, record) => (
        <H3Text text={`${record.first_name ? record.first_name : ''} ${record.last_name ? record.last_name : ''}`} className="prod-table__text" />
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'STATUS',
      render: (text, record) => (
        <H3Text text={record?.is_active ? 'Active' : 'Inactive'} className={record?.is_active ? 'status-tag' : 'status-tag__inactive'} />
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'PHONE',
      render: (text, record) => (
        <Fragment>
          <H3Text text={record?.mobile ? (`${CountryCodes?.find((code) => code?.dial_code == record?.dial_code)?.flag} +${record?.dial_code} ${record.mobile}`) : '-'} className="prod-table__text" />
        </Fragment>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'EMAIL',
      render: (text, record) => (
        <H3Text text={record.username ? record.username : '-'} className="prod-table__text" />
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: '',
      render: (text, record) => (
        <div className="member-list__actions">
          {Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT,
            Helpers.permissionTypes.UPDATE, user) && (
            <div
              className="roundIconButton"
              onClick={() => {
                setShowUpdateMemberModal(true);
                setSelectedMember(record);
              }}
            >
              <EditOutlined />
            </div>
          )}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
  ];

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left align-content-center">
                      <H3Text text={`${members?.data?.length || '0'} Team Members`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__buttons-wrapper">
                        <H3Button
                          buttonType={defaultButtonTypes.BLUE_ROUNDED}
                          text="+ Add New User"
                          onClick={() => setShowCreateMemberModal(true)}
                          customClass="add-button"
                        />
                      </div>
                    </div>
                  </div>
                )}
                showHeader
                loading={getMembersLoading}
                size="small"
                columns={rolecolumns}
                dataSource={members?.data || []}
                currentPage
                pagination={members?.data?.length > 10 ? {
                  defaultCurrent: 1,
                  pageSize: 10,
                  position: ['bottomRight'],
                  showSizeChanger: false,
                } : false}
                rowClassName={(record) => (!record?.is_active ? 'user-table__inactive' : '')}
                bordered
              />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showCreateMemberModal}
        onClose={() => setShowCreateMemberModal(false)}
        width="640px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '590px' }}>
            <H3Text text="Add New User" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowCreateMemberModal(false)} />
          </div>
        </div>
        <MemberForm
          callback={() => {
            setShowCreateMemberModal(false);
            setCall(!call);
          }}
        />
      </Drawer>
      <Drawer
        open={showUpdateMemberModal}
        onClose={() => setShowUpdateMemberModal(false)}
        destroyOnClose
        width="640px"
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '590px' }}>
            <H3Text text="Update User" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateMemberModal(false)} />
          </div>
        </div>
        <MemberForm
          callback={
            () => {
              setShowUpdateMemberModal(false);
              setCall(!call);
            }
          }
          selectedMember={selectedMember}
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, TenantReducers, MemberReducers,
}) => ({
  user: UserReducers.user,
  users: TenantReducers.users,
  members: MemberReducers.members,
  getMembersLoading: MemberReducers.getMembersLoading,
  updateUserLoading: UserReducers.updateUserLoading,
  roles: UserReducers.roles,
  getRolesLoading: UserReducers.getRolesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: (tenantId, roleId) => dispatch(TenantActions.getUsers(tenantId, roleId)),
  getRoles: (tenantId) => dispatch(UserActions.getRoles(tenantId)),
  updateUser: (payload, callback) => dispatch(UserActions.updateUser(payload, callback)),
  getMembers: () => dispatch(MemberActions.getMembers()),
});

Members.propTypes = {
  user: PropTypes.func,
  getMembers: PropTypes.func,
  getMembersLoading: PropTypes.bool,
  history: PropTypes.func,
  members: PropTypes.any,
  updateUserLoading: PropTypes.bool,
  updateUser: PropTypes.func,
  getRoles: PropTypes.func,
  roles: PropTypes.any,
  getRolesLoading: PropTypes.bool,
  location: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Members));
